import { createStore, del, delMany, get, keys, set } from 'idb-keyval';

// module-level createStore() 호출은 SSR 환경에서 indexedDB.open()을 즉시 실행해 ReferenceError를 유발함.
// lazy singleton으로 첫 실제 호출 시점에만 store를 초기화한다.
let _mlStore: ReturnType<typeof createStore> | undefined;

function getMlStore() {
  if (!_mlStore) {
    _mlStore = createStore('ml-models', 'model-cache');
  }
  return _mlStore;
}

// 캐시 키 = `${entryId}#${md5Hash}`
export async function getCachedModel(cacheKey: string): Promise<ArrayBuffer | undefined> {
  try {
    return await get<ArrayBuffer>(cacheKey, getMlStore());
  } catch {
    return undefined;
  }
}

export async function setCachedModel(cacheKey: string, buffer: ArrayBuffer): Promise<void> {
  try {
    await set(cacheKey, buffer, getMlStore());
  } catch {
    // IDB 저장 실패는 best-effort로 무시한다.
  }
}

export async function evictCacheKey(cacheKey: string): Promise<void> {
  try {
    await del(cacheKey, getMlStore());
  } catch {
    // best-effort
  }
}

// 같은 entryId의 이전 버전(stale) 삭제
export async function evictStaleModels(
  currentEntryId: string,
  currentCacheKey: string
): Promise<void> {
  try {
    const allKeys = await keys(getMlStore());
    const staleKeys = allKeys.filter(
      (key): key is string =>
        typeof key === 'string' && key.startsWith(`${currentEntryId}#`) && key !== currentCacheKey
    );

    if (staleKeys.length === 0) return;

    await delMany(staleKeys, getMlStore());
  } catch {
    // IDB 정리 실패는 best-effort로 무시한다.
  }
}
